import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  SUPPLIERS_INDEX_REQUESTED,
  SUPPLIERS_INDEX_SUCCESS,
  SUPPLIERS_INDEX_FAILURE,
  SUPPLIERS_CREATE_REQUESTED,
  SUPPLIERS_CREATE_SUCCESS,
  SUPPLIERS_CREATE_FAILURE,
  SUPPLIERS_UPDATE_REQUESTED,
  SUPPLIERS_UPDATE_SUCCESS,
  SUPPLIERS_UPDATE_FAILURE,
  SUPPLIERS_DELETE_REQUESTED,
  SUPPLIERS_DELETE_SUCCESS,
  SUPPLIERS_DELETE_FAILURE,
  CLEAR_NEW_SUPPLIER
} from '../types';

export const suppliersIndexRequested = () => {
  return {
    type: SUPPLIERS_INDEX_REQUESTED
  }
};

export const suppliersIndexSuccess = (suppliers) => {
  return {
    type: SUPPLIERS_INDEX_SUCCESS,
    payload: suppliers
  }
};

export const suppliersIndexFailure = () => {
  return {
    type: SUPPLIERS_INDEX_FAILURE
  }
};

export const suppliersCreateRequested = () => {
  return {
    type: SUPPLIERS_CREATE_REQUESTED
  }
};

export const suppliersCreateSuccess = (suppliers) => {
  return {
    type: SUPPLIERS_CREATE_SUCCESS,
    payload: suppliers
  }
};

export const suppliersCreateFailure = () => {
  return {
    type: SUPPLIERS_CREATE_FAILURE
  }
};


export const suppliersUpdateRequested = () => {
  return {
    type: SUPPLIERS_UPDATE_REQUESTED
  }
};

export const suppliersUpdateSuccess = (supplier) => {
  return {
    type: SUPPLIERS_UPDATE_SUCCESS,
    supplier: supplier
  }
};

export const suppliersUpdateFailure = () => {
  return {
    type: SUPPLIERS_UPDATE_FAILURE
  }
};


export const suppliersDeleteRequested = (supplierId) => {
  return {
    type: SUPPLIERS_DELETE_REQUESTED,
    supplierId: supplierId,
  }
};

export const suppliersDeleteSuccess = () => {
  return {
    type: SUPPLIERS_DELETE_SUCCESS,
  }
};

export const suppliersDeleteFailure = () => {
  return {
    type: SUPPLIERS_DELETE_FAILURE
  }
};

export const clearNewSupplier = () => {
  return {
    type: CLEAR_NEW_SUPPLIER,
  }
}

export const suppliersIndex = (signedPayload) => {
  return (dispatch) => {
    dispatch(suppliersIndexRequested());

    let endPoint = Config.baseUrl + Config.suppliers;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(suppliersIndexSuccess(response.data));
      })
      .catch((error) => {
        dispatch(suppliersIndexFailure());
      });
  }
}

export const deleteSupplier = (signedPayload, supplierId) => {
  return (dispatch) => {
    dispatch(suppliersDeleteRequested(supplierId));

    let endPoint = Config.baseUrl + Config.supplier + supplierId;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(suppliersDeleteSuccess());
      })
      .catch((error) => {
        dispatch(suppliersDeleteFailure());
      });
  }
}

export const createSupplier = (signedPayload, supplier, address) => {
  return (dispatch) => {
    dispatch(suppliersCreateRequested());

    let endPoint = Config.baseUrl + Config.suppliers;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    let body = {
      supplier: supplier,
      address: address
    }

    return Axios.post(endPoint, body, { headers: headers })
      .then((response) => {
        dispatch(suppliersCreateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(suppliersCreateFailure());
      });
  }
}

export const editSupplier = (signedPayload, supplier, address) => {
  return (dispatch) => {
    dispatch(suppliersUpdateRequested());

    let endPoint = Config.baseUrl + Config.supplier + supplier.id;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    let body = {
      supplier: supplier,
      address: address
    }

    return Axios.put(endPoint, body, { headers: headers })
      .then((response) => {
        dispatch(suppliersUpdateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(suppliersUpdateFailure());
      });
  }
}

export const clearNew = () => {
  return (dispatch) => {
    dispatch(clearNewSupplier());
  }
}
